import { constants } from "./general";
import { logAuth, logError, LogCategory } from "./sentryLogger";

const CLEVER_CLIENT_ID = process.env.REACT_APP_CLEVER_CLIENT_ID;
export const CLEVER_OAUTH_STATE_KEY = "clever_oauth_state";
export const CLEVER_OAUTH_ORIGINAL_PATH = "clever_oauth_original_path";

export const initiateCleverSignIn = async (redirectUri, additionalState = {}) => {
  const currentPath = window.location.pathname + window.location.search;
  const destination = redirectUri || currentPath;
  const isEducator = additionalState.isEducator || false;
  const hasGroupCode = !!additionalState.groupCode;

  try {
    if (!CLEVER_CLIENT_ID) {
      const error = new Error("Clever Client ID is not configured");
      logError("Clever OAuth initiation failed - missing client ID", error, {
        category: LogCategory.AUTH,
        authMethod: constants.CLEVER,
        originPath: currentPath,
        destination,
      });
      return { success: false, error };
    }

    // Log OAuth initiation
    logAuth("OAuth initiation started", {
      authMethod: constants.CLEVER,
      originPath: currentPath,
      destination,
      isEducator,
      hasGroupCode,
    });

    localStorage.setItem(CLEVER_OAUTH_ORIGINAL_PATH, currentPath);
    const state = JSON.stringify({
      nonce: Math.random().toString(36).substring(2),
      destination,
      provider: constants.CLEVER,
      ...additionalState
    });
    localStorage.setItem(CLEVER_OAUTH_STATE_KEY, state);

    const oauthUrl = new URL("https://clever.com/oauth/authorize");
    oauthUrl.searchParams.append("client_id", CLEVER_CLIENT_ID);
    oauthUrl.searchParams.append("redirect_uri", `${window.location.origin}/auth/callback`);
    oauthUrl.searchParams.append("response_type", "code");
    oauthUrl.searchParams.append("scope", "read:user_id read:sis");
    oauthUrl.searchParams.append("state", state);

    // Redirect to Clever's OAuth page
    window.location.href = oauthUrl.toString();
    return { success: true };
  } catch (e) {
    logError("Clever OAuth initiation failed", e, {
      category: LogCategory.AUTH,
      authMethod: constants.CLEVER,
      originPath: currentPath,
      destination,
    });
    return { success: false, error: e };
  }
};
